import { render, staticRenderFns } from "./laws.vue?vue&type=template&id=59644578&"
import script from "./laws.vue?vue&type=script&lang=js&"
export * from "./laws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports